// extracted by mini-css-extract-plugin
module.exports = {"list":"AuthorsMosaic_list__y328D","item":"AuthorsMosaic_item__xP4nM","filters":"AuthorsMosaic_filters___zvSw"};